import React from "react";
// @ts-ignore
import {Link} from "react-router-dom";
import Constants from "../../data/Constants";
import Colors from "../../assets/colors/Colors";
import styled from "styled-components";


const StyledRouterLink = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 50px;
    color: ${Colors.backgroundRed};
    
    &:hover {
        text-decoration: none;
    }
`;

const HomeGipChildrenComponent: React.FC = () => {

    return (
        <StyledRouterLink to={Constants.routes.economicResearch}>
          <span style={{color: 'black'}}>El&nbsp;</span> <span style={{color: Colors.headerNavigationRed}}> GIP - MAPFRE </span>
        </StyledRouterLink>
    );
};

export default HomeGipChildrenComponent;
